@if (global.data.isLoading) {
<ion-progress-bar type="indeterminate" color="danger"></ion-progress-bar>
}
@if (global.data.isOffline) {
<ion-toolbar class="offline-toolbar">
<ion-label>You are in the offline mode</ion-label>
</ion-toolbar>
}
